export const getI18n = (state) => state.i18n;